import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, ArrowRightOutlined } from '@ant-design/icons';
import api from '../services/api';
import './Login.css';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', values);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      message.success('登录成功');
      window.location.href = '/';
    } catch (err: any) {
      message.error(err.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="school-login">
      <div className="school-login-content"><div className="school-login-leaves" aria-hidden="true"><i /><i /><i /><span>EDUCATION<br />FOR A BRIGHTER<br />TOMORROW</span></div>
        <header className="school-login-brand">
          <img src="/school-logo-2026.png" alt="中关村外国语学校校徽" />
          <div><p>中关村外国语学校</p><span>初中部学生成长发展指导平台</span></div>
        </header>
        <section className="school-login-intro">
          <h1>让每一种成长<br />都绽放光芒</h1>
          <p>在这里，看见更好的自己</p>
        </section>
        <Form onFinish={onFinish} layout="vertical" size="large" requiredMark={false} className="school-login-form">
          <Form.Item label="账号" name="username" rules={[{ required: true, message: '请输入账号' }]}>
            <Input autoComplete="username" prefix={<UserOutlined />} placeholder="请输入账号" />
          </Form.Item>
          <Form.Item label="密码" name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password autoComplete="current-password" prefix={<LockOutlined />} placeholder="请输入密码" />
          </Form.Item>
          <Button className="school-login-submit" htmlType="submit" loading={loading} disabled={loading} block>
            <span>{loading ? '正在登录' : '登录'}</span><span className="school-login-arrow" aria-hidden="true"><ArrowRightOutlined /></span>
          </Button>
          <p className="school-login-help">忘记密码请联系班主任或管理员重置</p>
        </Form>
        <footer className="school-login-footer">记录每一步成长</footer>
      </div>
    </main>
  );
};
export default Login;
